var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-loader-wrapper"},[_c('h1',[_vm._v("Page Not Found 🕵🏻‍♀️")]),_c('p',[_vm._v(" Oops! 😖 The page you're looking for does not exist or have been temporarily unavailable. ")])])
}]

export { render, staticRenderFns }